import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import * as Constants from "Data/Constants";
import { TimelineLite } from "gsap";

export class MusicGameCountIn extends PIXI.Container {
    protected _debugText = this.addChild(HLF.PixiUtils.makeText("", Constants.FONT_GEL_MED_35, 70, 0xfcad2a));
    private readonly _subscriptions: any[];
    private readonly _timeline: TimelineLite = new TimelineLite();

    public constructor() {
        super();
        this._subscriptions = [
            PubSub.subscribe(Topics.RECORDING_COUNT_IN, (pTopic: string, pData: any)=>{
                this.show();
                this.countDown(pData);
            }),
            PubSub.subscribe(Topics.RECORDING_STARTED, (pTopic: string, pData: any)=>this.hide()),
            // PubSub.subscribe(Topics.RECORDING_ENDED, (pTopic: string, pData: any)=>this.hide()),
        ];
    }

    public destroy() {
        this._subscriptions.forEach(PubSub.unsubscribe);
        this._timeline?.kill();
        super.destroy();
    }

    public countDown(pFrom: number) {
        for(let i=0; i<pFrom; i++) {
            this._timeline.call(()=>{
                this._debugText.text = (pFrom - i).toString();
            }, undefined, undefined, i);
        }
    }

    public show(pAnimate: boolean = true, pCallback?: () => void): void {
        if (pAnimate) {
            this._timeline.clear();
            this.scale.set(1, 1);
            this._timeline.to(this, 0.25, {
                alpha: 1,
            });
            if (pCallback !== undefined) {
                this._timeline.call(pCallback);
            }
        }
        else {
            this.alpha = 1;
            if (pCallback !== undefined) {
                pCallback();
            }
        }
    }

    public hide(pAnimate: boolean = true, pCallback?: () => void): void {
        if (pAnimate) {
            this._timeline.clear();
            this._timeline.to(this, 0.5, {
                pixi: {
                    alpha: 0,
                },
            }, 0)
            .to(this, 0.25, {
                pixi: {
                    scaleX: 1.1,
                    scaleY: 1.1,
                },
            }, 0)
            .to(this, 0.25, {
                pixi: {
                    scaleX: 0.3,
                    scaleY: 0.3,
                },
            }, 0.25);

            if (pCallback !== undefined) {
                this._timeline.call(pCallback);
            }
        }
        else {
            this.alpha = 0;
            if (pCallback !== undefined) {
                pCallback();
            }
        }
    }
}